import type {HopperDeviceType} from './types'
import type {DeviceCategory} from '@vio/core/src/utils/userAgent/types'

/**
 * Maps our device categories to Hopper's expected device types
 */
export const HOPPER_DEVICE_TYPE_MAP: Record<DeviceCategory, HopperDeviceType> =
  {
    desktop: 'DesktopWeb',
    mobile: 'MobileWeb',
    tablet: 'MobileWeb'
  }

export const SUPPORTED_HOPPER_AD_COUNTRIES = new Set(['US', 'CA'])
